import { render, staticRenderFns } from "./InvoicesTwoComponent.vue?vue&type=template&id=776f6c9a&"
import script from "./InvoicesTwoComponent.vue?vue&type=script&lang=js&"
export * from "./InvoicesTwoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports